<div
  [class.compactCss]="compactCss()"
  class="form-field mb-2 d-inline-flex flex-column w-100"
>
  @if (!!label()) {
    <label [for]="id()" class="form-label" [style]="labelStyles()"
      >{{ label() }}
    </label>
  }

  <select
    [id]="id()"
    class="form-select"
    [(ngModel)]="value"
    [class.is-invalid]="
      control && control.touched && control.dirty && control.invalid
    "
  >
    @if (!!placeholder() || !!label()) {
      <option hidden value="" disabled class="unselectable-option placeholder">
        {{ placeholder() ? placeholder() : label() }}
      </option>
    }
    @for (item of options(); track $index) {
      <option
        [value]="item.value"
        [disabled]="!!item.disabled"
        [class.unselectable-option]="!!item.disabled"
      >
        {{ item.label }}
      </option>
    }
  </select>

  <b2c-form-field-errors
    class="mb-2"
    [control]="control"
    [errorMessages]="errorMessages()"
    [serverErrorMessage]="serverErrorMessage()"
  />
</div>
